export default __webpack_public_path__ + "static/media/two-sword.5982d312.png";